import React from 'react';
import { motion } from 'framer-motion';

const steps = [
  {
    number: '01',
    title: 'Discovery',
    description: 'We assess your current workflows, data landscape, and identify the highest-impact AI opportunities.',
  },
  {
    number: '02',
    title: 'Data Preparation',
    description: 'We label, clean, and structure your data into training-ready datasets tailored to your domain.',
  },
  {
    number: '03',
    title: 'Model Training',
    description: 'Using your curated data, we train or fine-tune AI models built specifically for your use cases.',
  },
  {
    number: '04',
    title: 'Integration & Launch',
    description: 'We embed AI into your existing tools and train your team so adoption is smooth and immediate.',
  },
];

export default function ProcessSection() {
  return (
    <section className="bg-slate-950 py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <span className="text-blue-400 text-sm font-semibold tracking-widest uppercase">Our Process</span>
          <h2 className="mt-4 text-3xl md:text-5xl font-bold text-white tracking-tight">
            Simple. Transparent. Effective.
          </h2>
        </motion.div>

        <div className="relative">
          <div className="hidden md:block absolute top-12 left-0 right-0 h-px bg-gradient-to-r from-transparent via-slate-700 to-transparent" />

          <div className="grid md:grid-cols-4 gap-8">
            {steps.map((step, i) => (
              <motion.div
                key={step.number}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.15, duration: 0.5 }}
                className="relative text-center"
              >
                <div className="inline-flex items-center justify-center w-24 h-24 rounded-full bg-slate-900 border-2 border-slate-700 mb-6 relative z-10">
                  <span className="text-2xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-amber-400">
                    {step.number}
                  </span>
                </div>
                <h3 className="text-xl font-semibold text-white mb-3">{step.title}</h3>
                <p className="text-slate-400 leading-relaxed text-sm">{step.description}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
